"use client";

import { c as _c } from "react/compiler-runtime";
import YouTubePlayer from "~/components/job-page/jobadvideo/youtube-eon";
import { useLanguage } from "~/translations/loader/use-language";
export default function DiversityEcon() {
  const $ = _c(8);
  const t = useLanguage();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <YouTubePlayer thumbnailSrc="images/jobad/econ/thumbnail_diversity.jpeg" videoId="1SkUB1s_Dh4" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t.econ_diversity_HL) {
    t1 = <h2 className="mb-8 font-bold text-4xl lg:w-96 xl:text-5xl">{t.econ_diversity_HL}</h2>;
    $[1] = t.econ_diversity_HL;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = t.econ_diversity_text || "";
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="text-lg print:text-sm [&>p]:mb-1" dangerouslySetInnerHTML={{
      __html: t2
    }} />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t3) {
    t4 = <section className="outer-container bg-primary py-container text-white print:hidden" id="diversity"><div className="inner-container grid gap-x-20 gap-y-12 lg:grid-flow-col lg:grid-cols-2">{t0}<div>{t1}{t3}</div></div></section>;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}